'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _FormHelperText = _interopRequireDefault(require("@material-ui/core/FormHelperText"));
var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));
var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));
var _CheckBoxOutlineBlank = _interopRequireDefault(require("@material-ui/icons/CheckBoxOutlineBlank"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
let app = window.app;
const styles = {
  Checkbox: {
    height: '21px',
    width: '21px',
    marginRight: '5px',
    marginLeft: '13px'
  },
  label: {
    fontFamily: 'inherit'
  }
};
class CustomCheckbox extends _react.PureComponent {
  componentDidMount() {
    const component = this,
      props = this.props;
    if (typeof props.value !== 'undefined') return;
    props.onChange({
      e: null,
      value: [true, 'true'].includes(props['default-value']),
      name: props.name,
      source: 'DidMount'
    });
  }
  handleChange = e => {
    const component = this,
      props = this.props;
    const {
      checked,
      name
    } = e.target;
    props.onChange({
      e: e,
      value: checked,
      name: name,
      source: 'native'
    });
  };
  render() {
    const component = this,
      props = this.props;
    let class_name = props.className;
    if (props['full-width']) {
      class_name += (class_name ? ' ' : '') + 'u-full-width';
    }
    let error_msg,
      status = props.status[props.name];
    if (status && status.error) {
      error_msg = /*#__PURE__*/_react.default.createElement(_FormHelperText.default, {
        error: true
      }, status.error);
    }
    let output = /*#__PURE__*/_react.default.createElement("div", {
      className: class_name
    }, /*#__PURE__*/_react.default.createElement(_FormControlLabel.default, {
      label: props.label,
      classes: {
        label: props.classes.label
      },
      control: /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
        onChange: component.handleChange,
        name: props.name,
        className: props.classes.Checkbox,
        checked: [true, 'true'].includes(props.value),
        color: "primary",
        icon: /*#__PURE__*/_react.default.createElement(_CheckBoxOutlineBlank.default, null),
        id: props.id
      })
    }), error_msg);
    return output;
  }
}
CustomCheckbox.propTypes = {
  'default-value': _propTypes.default.bool,
  'full-width': _propTypes.default.bool,
  name: _propTypes.default.string.isRequired,
  className: _propTypes.default.string,
  label: _propTypes.default.string,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
  classes: _propTypes.default.object.isRequired,
  status: _propTypes.default.object.isRequired,
  onChange: _propTypes.default.func.isRequired
};
CustomCheckbox.defaultProps = {
  'full-width': true,
  'default-value': false,
  className: ''
};
var _default = exports.default = (0, _styles.withStyles)(styles)(CustomCheckbox);
